import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["src"]

import SharedService from '@/services/SharedService';


export default /*@__PURE__*/_defineComponent({
  __name: 'esButtonIcon',
  props: {
    icon: {},
    disabled: { type: Boolean },
    styles: {},
    folder: {},
    buttonStyles: {}
  },
  setup(__props: any) {

const props = __props;

const getSvgClass = () => {
const mainClass = props.disabled ? 'img-disabled' : '';

const propsClass = props.styles ? props.styles : '';

return [mainClass, propsClass];
};

const getButtonClass = () => {

const mainClass = props.disabled ? 'button-disabled' : 'button-icon'

const propsClass = props.buttonStyles ? props.buttonStyles : '';

return [mainClass, propsClass];
};

const getIcon = (icon: string, isFillIcon: boolean, subPath: string) => {
  return SharedService.getIcon(icon, isFillIcon, subPath);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([getButtonClass(), "item-center"]),
    disabled: _ctx.disabled
  }, [
    _createElementVNode("img", {
      src: getIcon(_ctx.icon, false, _ctx.folder),
      class: _normalizeClass(getSvgClass())
    }, null, 10, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})